import { createMotionComponentFactory } from '../create-factory.mjs';

const createMinimalMotionComponent = 
/*@__PURE__*/ createMotionComponentFactory();

export { createMinimalMotionComponent };
